import React, { useState } from 'react'
import Card from '../nura/card/card'
import Modal from '../modal/modal'
import Button from '../nura/button/button'
import BaseForm from "../base-form/base-form"

import styles from './styles.module.css'
import useFlow from '../../hooks/useFlow'

export default ({ show, setShow, handleConnect, details }) => {
    const flow = useFlow({ onBack: () => setShow(false), onSubmit: handleConnect })
    const [tempValue, setTempValue] = useState(details?.inputs?.length > 0 ? {} : "")

    // TODO: add view button for hidden values.

    return (
        <Modal show={show} onClose={() => setShow(false)}>
            <Card variant="modal" style={{ width: 358 }}>
                <BaseForm onBack={() => setShow(false)} title={`Connect ${details?.name}`}>
                    {
                        flow.step === 0 ? (
                            <>
                                <div className={styles.menuDescription}>
                                    <div>{details?.apiKeyLocation}</div>
                                </div>
                                <div className={styles.textAreaContainer} styles={{ marginBottom: 5}}>
                                    {
                                        details?.inputs?.length >0 ? (
                                            <>
                                            {details?.inputs.map(x => (
                                                <>
                                                    <div className={styles.textAreaLabel}>{x}</div>
                                                    <input
                                                        type="password"
                                                        className={styles.textArea}
                                                        rows={5}
                                                        onChange={({ target: { value } }) => setTempValue((prev) => ({
                                                            ...prev,
                                                            [x]:value,
                                                        }))}
                                                    />
                                                </>
                                            ))}
                                            </>
                                        ) : (
                                            <>
                                                <div className={styles.textAreaLabel}>API Key</div>
                                                <input
                                                    className={styles.textArea}
                                                    rows={5}
                                                    onChange={({ target: { value } }) => setTempValue(value)}
                                                />
                                            </>
                                        )
                                    }
                                </div>
                                <div className={styles.actionGroup}>
                                    <Button style={{ width: '100%' }} variant="outline" onClick={() => flow.onClickChange('apiKey')(tempValue)}>Next</Button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={styles.menuDescription}>
                                    <div>
                                        <p>
                                            By connecting your {details?.name} account, you authorize Nura Flow to make API requests on your behalf using your API key. This allows us to provide seamless integration and enhanced functionality.<br /><br />
                                            You accept responsibility for any charges associated with these API requests. Nura Flow will only use your API key for the purpose of fulfilling your requests and does not store or share your API key with unauthorized parties.<br />
                                            <br />
                                            You may revoke access at any time by disconnecting your account in the settings.
                                        </p></div>
                                </div>
                                <div className={styles.actionGroup}>
                                    <Button style={{ width: '100%' }} variant="primary" onClick={() => flow.finalStageSubmit('info')(details)}>Connect</Button>
                                </div>
                            </>
                        )
                    }
                </BaseForm>
            </Card>
        </Modal>
    )
}